<template>
  <div>
    <p>Empty Main Page</p>
  </div>
  
</template>

<script>
export default {
  
}
</script>

<style scoped>

</style>